module.exports = __webpack_public_path__ + "i18n/ko.311344caa7f0c303fffa3161baa781ae.json";